export const HealthClassOptions = [
    {
        name: 'Exceptionally healthy',
        id: 'uiPPInfo',
        value: 'PP',
        subName: '(Preferred Plus)',
        description: 'Very healthy with no history of major impairments, hazardous activities or substance abuse.',
        descriptionList: [
            'Your client has no health impairment history (diabetes, cancer, heart disease, substance abuse, etc)',
            'Your client has no family history (parent or sibling) of heart disease or cancer prior to age 65',
            "Your client's blood pressure and cholesterol are under excellent control",
            'Your client does not participate in hazardous activities (work or recreational)',
            'Your client has not had more than 2 moving violations or DUIs in the past 5 years'
        ],
    },
    {
        name: 'Very healthy',
        id: 'uiPInfo',
        value: 'P',
        subName: '(Preferred)',
        description: 'Good health with no history of major impairments or substance abuse.',
        descriptionList: [
            'Your client has no health impairment history (diabetes, cancer, heart disease, substance abuse, etc)',
            'Your client has no family history (parent or sibling) of heart disease or cancer prior to age 60',
            "Your client's blood pressure and cholesterol are under excellent control",
            'Your client may participate in certain hazardous activities (work or recreational)',
            'Your client has not had more than 2 moving violations or DUIs in the past 5 years'
        ],
    },
    {
        name: 'Above average health',
        id: 'uiRPInfo',
        value: 'RP',
        subName: '(Standard Plus)',
        description: 'Some minor health impairments, moving violations and some hazardous activities.',
        descriptionList: [
            'Your client may have some minor health impairments',
            'Your client has no family history (parent or sibling) of heart disease or cancer prior to age 60',
            "Your client's blood pressure and cholesterol are under good control",
            'Your client may participate in certain hazardous activities (work or recreational)',
            'Your client has not had more than 2 moving violations or DUIs in the past 5 years or substance abuse history in the last 7 years'
        ],
    },
    {
        name: 'Average health',
        id: 'uiRInfo',
        value: 'R',
        subName: '(Standard)',
        description: 'Some health impairments, blood pressure or cholesterol issues, and moving violations.',
        descriptionList: [
            'Your client may have some health impairments',
            "Your client's blood pressure and/or cholesterol may be slightly elevated",
            'Your client has had more than 2 moving violations or a DUI in the past 5 years, or substance abuse history in the last 7 years'
        ],
    },
]


// WEBPACK FOOTER //
// ./src/components/Helpers/Lists/HealthClassOptions.js